import React from 'react';
import styles from '../../styles/PrivacyPolicy.module.css';
import { useNoSidebar } from '../../hooks/useNoSidebar';

const PrivacyPolicy: React.FC = () => {
  useNoSidebar();

	return (
		<div className={styles.container}>
			<div className={styles.panel}>
				<h2>Legal Documentation</h2>

				<p>
					If you require our legal documentation again, you can download it
					using the links below.
				</p>

				<ul>
					<li>
						<span>Terms &amp; Conditions</span>
						<a href="https://tfqdthhcjdzxoopraupl.supabase.co/storage/v1/object/public/legal_docs/Realty_Genie_Terms_and_Conditions.pdf" target="_blank" rel="noopener noreferrer">
							View Document
						</a>
					</li>

					<li>
						<span>Privacy Policy</span>
						<a href="https://tfqdthhcjdzxoopraupl.supabase.co/storage/v1/object/public/legal_docs/Realty_Genie_Privacy_Notice.pdf" target="_blank" rel="noopener noreferrer">
							View Document
						</a>
					</li>
					<li>
						<span>PAIA Manual</span>
						<a href="https://tfqdthhcjdzxoopraupl.supabase.co/storage/v1/object/public/legal_docs/Realty_Genie_PAIA_Manual.pdf" target="_blank" rel="noopener noreferrer">
							View Document
						</a>
					</li>
					<li>
						<span>Data Processing Agreement</span>
						<a href="https://tfqdthhcjdzxoopraupl.supabase.co/storage/v1/object/public/legal_docs/Realty_Genie_Privacy_Notice.pdf" target="_blank" rel="noopener noreferrer">
							View Document
						</a>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default PrivacyPolicy;
